/* ============
 * Perimeters Mutations
 * ============
 *
 * The mutations available for the perimeter module.
 */

export const ALL = 'ALL';
export const ALL_OPTIONS = 'ALL_OPTIONS';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const GET_SELECTED_PERIMETER = 'GET_SELECTED_PERIMETER';
export const ALL_USERS = 'ALL_USERS';
export const SET_CURRENT_PAGE_USER = 'SET_CURRENT_PAGE_USER';

export default {
  ALL,
  ALL_OPTIONS,
  SET_CURRENT_PAGE,
  GET_SELECTED_PERIMETER,
  ALL_USERS,
  SET_CURRENT_PAGE_USER,
};



// WEBPACK FOOTER //
// ./src/store/modules/perimeters/mutation-types.js